window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Carry the active company to API requests. API routes do not use the web
// session, so XHR requests must pass the active company explicitly via a
// header. Read it at request time so initialization order with window.bo
// does not matter.
window.axios.interceptors.request.use((config) => {
    if (window.bo && window.bo.companyId) {
        config.headers["X-Bo-Company-Id"] = window.bo.companyId;
    }
    return config;
});

// Silently refresh the access token on 401 and retry, for the global axios instance too.
import { installRefreshInterceptor } from "./refresh-interceptor";
installRefreshInterceptor(window.axios);

// Log the user out after a period of real inactivity, even on pages that make no
// authenticated requests (the server-side idle check only fires at token-refresh time).
import { startIdleWatch } from "./session-idle";
startIdleWatch();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import api from "./api";
import setAuthToken from "./token";

// An in-page cart navigation can receive a freshly rotated token from its
// server-rendered page boot without running bootstrap.js again.
window.boAdoptAuthToken = setAuthToken;

const currentUrl = new URL(window.location.href);
const redirectToken = currentUrl.searchParams.get("token");

if (redirectToken) {
    setAuthToken(redirectToken);
    currentUrl.searchParams.delete("token");
    window.history.replaceState({}, document.title, currentUrl.toString());
}

// The server silently refreshed the access token while rendering this page (the httpOnly
// refresh cookie made it possible without any client involvement). Our stored copy is now the
// old, expired one, and it is what every XHR from this page would carry — so adopt the new
// token here. Without this the page is authenticated server-side and expired client-side, and
// the drift only widens with each JWT_TTL that passes.
if (window.bo_refreshed_token) {
    setAuthToken(window.bo_refreshed_token);
} else if (localStorage.getItem("token_" + window.bo_site)) {
    setAuthToken(localStorage.getItem("token_" + window.bo_site));
}

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    key: window.bo_websocket_key,
    cluster: window.bo_websocket_cluster,
    encrypted: true,
    wsHost: window.bo_domain,
    wsPort: window.bo_websocket_port,
    wssPort: window.bo_websocket_port,
    forceTLS: true,
    disableStats: false,
    enabledTransports: ["ws", "wss"],
});
